import React from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'
import DesignTemplateModal from './DesignTemplateModal'
import BookNowButton from '../../ui/BookNowButton'

@observer
export default class DesignTemplateThumbnail extends React.Component {
  static propTypes = {
    designTemplate: PropTypes.object.isRequired,
    showBookNowButton: PropTypes.bool.isRequired,
    bookNowButtonText: PropTypes.string.isRequired,
    style: PropTypes.any,
    buttonBackgroundColor: PropTypes.string,
    buttonForegroundColor: PropTypes.string,
    textColor: PropTypes.string,
  }

  state = {
    showModal: false
  }

  handleShow = () => {
    this.setState({ showModal: true })
  }

  handleClose = () => {
    this.setState({ showModal: false })
  }

  renderTitle() {
    const { designTemplate } = this.props

    if(designTemplate.attributes.priceFormatted) {
      return `${designTemplate.attributes.name}: ${designTemplate.attributes.priceFormatted}`
    }
    else {
      return designTemplate.attributes.name
    }
  }

  render() {
    const { designTemplate, style, showBookNowButton, bookNowButtonText, textColor, buttonBackgroundColor, buttonForegroundColor } = this.props
    const { showModal } = this.state

    let titleStyle = {...styles.title}
    if(textColor) {
      titleStyle.color = textColor
    }

    return (
      <div style={{...styles.container, ...style}}>
        <DesignTemplateModal
          showBookNowButton={showBookNowButton}
          bookNowButtonText={bookNowButtonText}
          show={showModal}
          onClose={this.handleClose}
          designTemplate={designTemplate}
        />
        <div style={titleStyle} onClick={this.handleShow}>
          { this.renderTitle() }
        </div>
        <div onClick={this.handleShow} >
          <img
            src={designTemplate.attributes.primaryImage.videoVariant}
            style={styles.image}
            loading="lazy"
          />
        </div>

        <div style={styles.bookNowContainer}>
          <BookNowButton
            showBookNowButton={showBookNowButton}
            booknowButtonText={bookNowButtonText}
            buttonBackgroundColor={buttonBackgroundColor}
            buttonForegroundColor={buttonForegroundColor}
          />
        </div>
      </div>
    )
  }
}

const styles = {
  container: {
    cursor: 'pointer'
  },
  title: {
    fontSize: 18,
    fontWeight: "bold",
    color: "#000",
    textAlign: "center"
  },
  image: {
    maxWidth: "100%",
    width: "auto",
    height: "auto"
  },
  bookNowContainer: {
    marginTop: 10,
    textAlign: "center"
  }
}
